<div class="container-fluid bg-black d-md-block d-none">
  <div class="container px-0 py-1 d-flex flex-wrap gap-3 align-items-end justify-content-end">
    <div *ngIf="isLoggedIn; else guestLinks">
      <p class="text-white m-0 small-font main-footer-links fw-normal c-pointer d-flex align-items-center">
        {{ user.name || "" }}<i class="icon-User_filled ps-2"></i>
      </p>
    </div>
    <ng-template #guestLinks>
      <a *ngIf="!isOnRegisterPage" href="" routerLink="/register">
        <p class="text-white m-0 small-font main-footer-links fw-normal c-pointer d-flex align-items-center">Register</p>
      </a>
      <div *ngIf="!isOnLoginPage && !isOnRegisterPage" class="vr text-white opacity-100"></div>
      <a *ngIf="!isOnLoginPage" href="" routerLink="/login">
        <p class="text-white m-0 small-font main-footer-links fw-normal c-pointer d-flex align-items-center">Login
          <i class="icon-User_filled ps-2"></i>
        </p>
      </a>
    </ng-template>
  </div>
</div>

<div class="container-fluid d-md-none mobile-topbar ">
  <div class="container p-0">
    <div class="d-flex justify-content-between align-items-center my-3">

      <div>
        <a class="c-pointer" [attr.href]="vettimesUrl"><img alt="" loading="lazy" width="25" height="25" decoding="async" data-nimg="1"
          class="logo c-pointer my-0" style="color:transparent" src={{logoBlack}}></a>
      </div>

      <div class="d-flex align-items-center gap-3">

        <!-- <a *ngIf="!isOnRegisterPage" class="lh-1" routerLink="/register"><i class="icon-User_filled font-20"></i></a>
        <a *ngIf="!isOnLoginPage" class="lh-1" routerLink="/login"><i class="icon-User_filled font-20"></i></a> -->

        <div class="canvas-menu">

          <button class="btn text-black p-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"
            aria-controls="offcanvasRight">
            <i class="icon-menu font-20"></i>
          </button>

          <div class="offcanvas offcanvas-end bg-dark-green" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
            <button type="button" class="btn-close btn-rounded opacity-100 close" data-bs-dismiss="offcanvas" aria-label="Close"></button>

            <div class="offcanvas-body mt-3 d-flex flex-column">
              <div id="accordionExample" class="d-flex flex-column">
                <div class="accordion-item border-bottom">

                  <button class="bg-none px-0 pb-3 pt-3 d-flex justify-content-between border-0 w-100 align-items-center collapsed"
                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseNews" aria-expanded="true"
                    aria-controls="collapseNews" style="background-color: transparent;">
                    <h3 class="text-white font-21 font-fraunces fw-bold mb-0">News</h3>
                    <i class="icon-angle-right text-white font-20"></i>
                  </button>

                  <div id="collapseNews" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <ul class="list-group pb-3">

                        <li class="list-group-item bg-transparent border-0 text-white p-0">
                          <a [attr.href]="vettimesUrl">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">View all<!-- --> <!-- -->news</h5>
                          </a>
                        </li>

                        <li class="list-group-item border-0 text-white p-0" style="background-color:transparent">
                          <a [attr.href]="vettimesUrl + 'news/vets'">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Vets<!-- --> <!-- -->news</h5>
                          </a>
                        </li>

                        <li class="list-group-item border-0 text-white p-0" style="background-color:transparent">
                          <a [attr.href]="vettimesUrl + 'news/vet-nursing'">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Vet Nursing<!-- --> <!-- -->news</h5>
                          </a>
                        </li>

                        <li class="list-group-item border-0 text-white p-0" style="background-color:transparent">
                          <a [attr.href]="vettimesUrl + 'news/business'">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Business<!-- --> <!-- -->news</h5>
                          </a>
                        </li>

                        <li class="list-group-item bg-transparent border-0 text-white p-0">
                          <a class="" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseExample"
                            href="#collapseExample">
                            <h5 class="text-white mb-0 fw-normal">+ More</h5>
                          </a>

                          <div class="collapse" id="collapseExample">
                            <ul class="list-group py-0 px-2">
                              <li class="list-group-item bg-transparent border-0 text-white py-0">
                                <a href="/more/videos">
                                  <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Videos</h5>
                                </a>
                              </li>

                              <li class="list-group-item bg-transparent border-0 text-white py-0">
                                <a href="/more/podcast">
                                  <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Podcasts</h5>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item border-bottom">
                  <button class="bg-none px-0 pb-3 pt-3 d-flex justify-content-between border-0 w-100 align-items-center collapsed"
                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseClinical" aria-expanded="true"
                    aria-controls="collapseClinical" style="background-color:transparent">
                    <h3 class="text-white font-21 font-fraunces fw-bold mb-0">Clinical</h3>
                    <i class="icon-angle-right text-white font-20"></i>
                  </button>

                  <div id="collapseClinical" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <ul class="list-group pb-3">
                        <li class="list-group-item bg-transparent border-0 text-white p-0">
                          <a [attr.href]="vettimesUrl + 'clinical'">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">View all<!-- --> <!-- -->clinical</h5>
                          </a>
                        </li>

                        <li class="list-group-item border-0 text-white p-0" style="background-color:transparent">
                          <a [attr.href]="vettimesUrl + 'clinical/small-animal'">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Small animal<!-- --> </h5>
                          </a>
                        </li>

                        <li class="list-group-item border-0 text-white p-0" style="background-color:transparent">
                          <a [attr.href]="vettimesUrl + 'clinical/livestock'">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Livestock<!-- --> </h5>
                          </a>
                        </li>

                        <li class="list-group-item border-0 text-white p-0" style="background-color:transparent">
                          <a [attr.href]="vettimesUrl + 'clinical/equine'">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Equine<!-- --> </h5>
                          </a>
                        </li>

                        <li class="list-group-item border-0 text-white p-0" style="background-color:transparent">
                          <a [attr.href]="vettimesUrl + 'clinical/exotics'">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Exotics<!-- --> </h5>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item border-bottom">
                  <button class="bg-none px-0 pb-3 pt-3 d-flex justify-content-between border-0 w-100 align-items-center collapsed"
                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseJobs" aria-expanded="true"
                    aria-controls="collapseJobs" style="background-color:transparent">
                    <h3 class="text-white font-21 font-fraunces fw-bold mb-0">Jobs</h3>
                    <i class="icon-angle-right text-white font-20"></i>
                  </button>

                  <div id="collapseJobs" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <ul class="list-group pb-3">
                        <li class="list-group-item bg-transparent border-0 text-white p-0">
                          <a [attr.href]="vettimesUrl + 'jobs'">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Vet Times<!-- --> jobs home</h5>
                          </a>
                        </li>

                        <li class="list-group-item border-0 text-white p-0" style="background-color:transparent">
                          <a [attr.href]="allJobsUrl">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">All Jobs<!-- --> </h5>
                          </a>
                        </li>

                        <li class="list-group-item border-0 text-white p-0" style="background-color:transparent">
                          <a [attr.href]="myJobsUrl">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Your ideal job<!-- --> </h5>
                          </a>
                        </li>

                        <li class="list-group-item border-0 text-white p-0" style="background-color:transparent">
                          <a [attr.href]="recruitersUrl">
                            <h5 class="text-white mb-0 fw-normal" data-bs-dismiss="offcanvas">Post a job<!-- --> </h5>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-auto pt-3">
                <div class="mt-4">
                  <a [attr.href]="vettimesUrl + 'about-us'">
                    <h5 class="text-white mb-3 font-17 fw-normal" data-bs-dismiss="offcanvas">About</h5>
                  </a>

                  <a [attr.href]="vettimesUrl + 'contact-us'">
                    <h5 class="text-white mb-3 font-17 fw-normal" data-bs-dismiss="offcanvas">Contact Us</h5>
                  </a>

                  <a href="#">
                    <h5 class="text-white mb-3 font-17 fw-normal" data-bs-dismiss="offcanvas">For Advertisers</h5>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="px-lg-0 px-3">
  <div class="container navbar py-0 pt-md-4">
    <div class="d-flex align-items-end justify-content-between w-100">
      <div class="d-flex gap-lg-5 gap-3 primary-main">
        <a class="mb-sm-0 pb-2 fw-bold primary-navbar-btn c-pointer" [attr.href]="vettimesUrl">News</a>
        <a class="mb-sm-0 pb-2 fw-bold primary-navbar-btn c-pointer" [attr.href]="vettimesUrl + 'clinical'">Clinical</a>
        <a class="mb-sm-0 pb-2 fw-bold primary-navbar-btn c-pointer" [attr.href]="vettimesUrl + 'jobs'">Jobs</a>
      </div>
      <div class="pb-3 d-md-block d-none">
        <a class="c-pointer" [attr.href]="vettimesUrl" target="">
          <img src={{logoBlack}} alt="">
        </a>
      </div>
    </div>
  </div>
</div>
